import { useNavigate, useParams } from 'react-router-dom';
import { MovieDetails } from '../components/ui/MovieDetails';
import { useMovies } from '../hooks/useMovies';
import { Movie } from '../types';

interface MoviePageProps {
    onBook: (movie: Movie) => void;
}

export default function MoviePage({ onBook }: MoviePageProps) {
    const { id } = useParams<{ id: string }>();
    // We use useMovies hook which is cached.
    // Ideally we would trigger a fetch for single movie if not present.
    const { data: movies = [] } = useMovies();
    const navigate = useNavigate();

    if (!id) return null;

    const movie = movies.find(m => m.id === Number(id));

    if (!movie) {
        // Show loading or not found
        return <div className="text-white text-center py-20">Loading or Movie Not Found...</div>
    }

    const movieForDetails: Movie = {
        ...movie,
        genre: movie.genre ?? 'movie',
        rating: movie.rating ?? 9.5,
        backdropUrl: movie.backdropUrl ?? movie.image_url
    };

    return (
        <div className="pt-20">
            <MovieDetails
                // @ts-ignore - ExtendedMovie type mismatch with Movie type from useMovies
                movie={movieForDetails}
                onBack={() => navigate(-1)}
                onBook={() => onBook(movie)}
            />
        </div>
    );
}
